<template>
    <div class="modal-full">
        <div class="modal-header">
            <close-icon v-on:click="closeView"></close-icon>
            <h1>Update Promotion</h1>
        </div>
        <div class="modal-body no-pad">
            <div class="flex h-full" v-if="promotion">
                <div class="promotion-sidebar h-full">
                    <div class="mb-4 text-center">
                        <p class="text-lg font-light">{{ promotion.code }}</p>
                    </div>

                    <div class="mb-3">
                        <label>Discount Type</label>
                        <p v-if="promotionType === 'percentage'">Percentage</p>
                        <p v-if="promotionType !== 'percentage'">Fixed Amount</p>
                    </div>

                    <div class="mb-3">
                        <label>Discount Amount</label>
                        <p v-if="promotionType === 'percentage'">{{ promotion.percentage * 100 }}%</p>
                        <p v-if="promotionType !== 'percentage'">{{ promotion.fixed_amount }}</p>
                    </div>

                </div>
                <div class="promotion-body">
                    <div class="form-field">
                        <label>Title</label>
                        <input type="text" v-model="promotion.title" placeholder="Title">
                    </div>
                    <div class="form-field">
                        <label>Description</label>
                        <input type="text" v-model="promotion.description" placeholder="Description">
                    </div>
                    <div class="form-field">
                        <label>Products</label>
                        <picker-selector placeholder="Select Products"
                                         :value="promotionProducts"
                                         input-name="products[]"
                                         @input="addProduct"
                                         route="products.select">
                        </picker-selector>
                    </div>
                    <div class="form-field">
                        <label>Packages</label>
                        <picker-selector placeholder="Select Packages"
                                         :value="promotionPackages"
                                         input-name="packages[]"
                                         @input="addPackage"
                                         route="packages.select">
                        </picker-selector>
                    </div>
                    <div class="form-field">
                        <label>Expiry Date</label>
                        <simple-date-time-picker
                            v-model="promotion.expires">
                        </simple-date-time-picker>
                    </div>
                    <div class="form-field">
                        <label>Number of Uses</label>
                        <input type="number" v-model="promotion.max_uses" placeholder="1">
                    </div>
                    <div class="form-field">
                        <label>Number of Uses per User</label>
                        <input type="number" v-model="promotion.max_uses_user" placeholder="1">
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <div class="flex">

                <div class="middle text-middle">

                </div>

                <div class="right text-right">
                    <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>
                    <button class="btn-primary" type="button" @click="savePromotion">Save</button>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
    export default {
        name: 'PromotionsShow',
        props: {},
        data() {
            return {
                packages: null,
                products: null,
                promotion: null,
                promotionPackages: [],
                promotionProducts: [],
                promotionType: 'percentage',
                months: 1,
            }
        },
        mounted() {
            this.loadData();
        },
        methods: {
            loadData() {
                axios.get(route('promotions.show', this.$route.params.code))
                    .then(response => {
                        this.packages = response.data.packages;
                        this.products = response.data.products;
                        this.promotion = response.data.promotion;
                        this.promotionPackages = response.data.selectedPackages;
                        this.promotionProducts = response.data.selectedProducts;

                        this.setMetaTitle('Update Promotion | JournoLink Control')
                    })
                    .catch(e => {
                        console.error({e})
                    })
            },
            savePromotion() {
                this.promotion.expires = this.moment(this.promotion.expires).format('YYYY-MM-DD HH:mm:ss');
                axios.put(route('promotions.update', this.$route.params.code),
                    {
                        "promotion": this.promotion,
                        "packages": this.promotionPackages,
                        "products": this.promotionProducts,
                        "months": this.months,
                    }
                ).then(response => {
                    this.$bus.$emit('alert.success', 'Update Success');

                    this.promotion = response.data.promotion;
                    this.promotionPackages = response.data.packages;
                    this.promotionProducts = response.data.products;

                    this.closeView();
                }).catch(e => {
                    console.error({e});
                });
            },
            /**
             * Emit the close event to the parent
             *
             * @return {void}
             */
            closeView() {
                this.$root.goBack()
            },
            addPackage(ids) {
                this.promotionPackages = ids;
            },
            addProduct(ids) {
                this.promotionProducts = ids;
            },
            /**
             * Handle an [Escape] keypress
             *
             * @return {void}
             */
            onEscapeKeypress() {
                this.closeView()
            },
        },
        computed: {
            //
        }
    }
</script>

<style lang="less">

    .promotion-sidebar {
        padding: 15px;
        width: 350px;
        font-size: 0.9rem;
        background: #f6f6f6;

        label {
            font-weight: bold;
            font-size: 0.8em;
            color: #999999;
        }

        p {
            margin-bottom: 0.5em;
        }
    }

    .promotion-body {
        flex: 1;
        padding: 15px;
    }

    .promotion-type {
        margin: 20px 0 5px;

        input {
            margin-left: 20px;

            &:first-child {
                margin-left: 0;
            }
        }
    }

</style>
